import { render } from "./Sent_SMS.vue?vue&type=template&id=1f51057a"
import script from "./Sent_SMS.vue?vue&type=script&lang=js"
export * from "./Sent_SMS.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__